
		import Async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function (require) {
				cb( require("!!../../../../node_modules/babel-loader/lib/index.js??ref--0!./DefaultTemplate.js") );
			});
		}

		export default Async(load);
	


//////////////////
// WEBPACK FOOTER
// ../node_modules/preact-cli/lib/lib/webpack/async-component-loader.js!./components/templates/default/DefaultTemplate.js
// module id = null
// module chunks = 